/**
 * MINIMAL Fabric.js Test - Does it work at all?
 */

import { useEffect, useRef } from 'react';
import * as fabric from 'fabric';

export function FabricTest() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    console.log('🧪 MINIMAL TEST: Initializing Fabric.js...');

    const canvas = new fabric.Canvas(canvasRef.current, {
      width: 600,
      height: 600,
      backgroundColor: '#f0f0f0'
    });

    console.log('✅ Canvas created:', canvas);

    // Add a simple red rectangle
    const rect = new fabric.Rect({
      left: 50,
      top: 50,
      width: 100,
      height: 100,
      fill: 'red'
    });

    canvas.add(rect);
    console.log('🔴 Rectangle added');

    canvas.renderAll();
    console.log('🎨 Rendered');

    // Handle file upload
    const handleFileUpload = (e: Event) => {
      const file = (e.target as HTMLInputElement).files?.[0];
      if (!file) return;

      console.log('📁 File selected:', file.name);

      const reader = new FileReader();
      reader.onload = (event) => {
        const imgElement = new Image();
        imgElement.onload = () => {
          console.log('🖼️ Image loaded:', imgElement.width, 'x', imgElement.height);

          const fabricImg = new fabric.Image(imgElement, {
            left: 150,
            top: 150,
            scaleX: 0.3,
            scaleY: 0.3
          });

          canvas.add(fabricImg);
          canvas.renderAll();
          console.log('✅ Image added to canvas');
        };
        imgElement.src = event.target?.result as string;
      };
      reader.readAsDataURL(file);
    };

    const fileInput = fileInputRef.current;
    fileInput?.addEventListener('change', handleFileUpload);

    return () => {
      fileInput?.removeEventListener('change', handleFileUpload);
      canvas.dispose();
    };
  }, []);

  return (
    <div style={{ padding: '50px', backgroundColor: 'white' }}>
      <h1>Fabric.js Minimal Test</h1>
      <p>Should see a RED rectangle below:</p>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ marginBottom: '20px', display: 'block' }}
      />
      <canvas ref={canvasRef} style={{ border: '2px solid black' }} />
    </div>
  );
}
